import { useSelector } from 'react-redux';
import { RootState } from '../redux/rootReducer'
import { BookDb } from '../redux/bookDbSlice'

const useOneBookDb = (id: string | undefined) : BookDb| undefined => {
  const bookDb = useSelector((state: RootState) => state.bookDb)
  const bookValue = id ? bookDb.books[id] : undefined
  return bookValue
}

export default useOneBookDb